import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";

import { report_car_receipt, report_installation_summary, report_repair, report_receipt_tax } from "../../../components/Report.js";
export default class Repairs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_status: "",

      data: [],
      count: 10,
      data_customer: [],
      data_user: [],
      data_warehouse: [],

      id: "",
      uid: "",
      date: "",
      type: "",
      customer_id: "",
      customer_name: "",
      address: "",
      phone: "",
      car_registration: "",
      brand: "",
      model: "",
      cause: "",
      status: "",
      user_id: "",
      warehouse_id: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search, filter_start_date, filter_end_date, filter_status } =
      this.state;
    let data, count, data_customer, data_user, data_warehouse;
    loading(true);
    let [result, result_customer, result_user, result_warehouse] =
      await Promise.all([
        GET("admin/repairs/list", {
          page: page,
          data_search: filter_search,
          start_date: filter_start_date
            ? format_date(filter_start_date, "yyyy-mm-dd", "en")
            : "",
          end_date: filter_end_date
            ? format_date(filter_end_date, "yyyy-mm-dd", "en")
            : "",
          status_code: filter_status,
        }),
        GET("admin/setting/customers/list", {
          page: 0,
          data_search: "",
        }),
        GET("admin/setting/users/list", {
          page: 0,
          data_search: "",
          user_type: "technical",
        }),
        GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }

    if (result_customer?.status) {
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
        label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
        full_name: e.full_name,
        phone: e.phone,
      }));
    }
    if (result_user?.status) {
      data_user = result_user.data.map((e) => ({
        value: e.uid,
        label: e.full_name,
        warehouse_list: e.warehouse_list
      }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
        id: e.id
      }));
    }
    this.setState({
      data,
      count,
      data_customer,
      data_user,
      data_warehouse,
    });
    loading(false);
  };
  Create = async () => {
    const {
      uid,
      date,
      type,
      customer_id,
      customer_name,
      address,
      phone,
      car_registration,
      brand,
      model,
      cause,
      status,
      user_id,
      warehouse_id,
    } = this.state;

    loading(true);
    let body = {
      date,
      type,
      customer_id,
      customer_name: customer_name || type === "ประกอบ" ? "-" : "",
      address: address || type === "ประกอบ" ? "-" : "",
      phone: phone || type === "ประกอบ" ? "0" : "",
      car_registration,
      brand,
      model,
      cause,
      status: "เข้าซ่อม",
      user_id,
      warehouse_id,
    };

    let result = await POST("admin/repairs/create", body);
    if (result?.status) {
      alert("#", "success");
      report_car_receipt(result.data);
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  Delete = async (id) => {
    let result = await GET("admin/repairs/list", {
          uid: id,
        });if(result.data?.stock_activity_list?.length !== 0){
          await alert(
        "",
        "warning",
        "แจ้งเตือน",
        "ไม่สามารถลบข้อมูลได้ เนื่องจากมีใบเบิกคงค้างอยู่ กรุณาลบใบเบิกทั้งหมดก่อนทำการลบข้อมูลนี้"
      )
      return;
        }
    if (
      await alert(
        "",
        "warning",
        "ยกเลิกข้อมูล",
        "ยืนยันการยกเลิกรายการนี้หรือไม่ ? \n ",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await PUT("admin/repairs/update/" + id, { status: "ยกเลิก" });
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  CreateCustomer = async () => {
    const { uid, customer_name, phone } = this.state; 
    loading(true);
    let body = {
      prefix_name: "",
      full_name: customer_name,
      address: "",
      phone,
      tax_number: "",
      payment_conditions: "",
      cars: [],
    };

    let result = await POST("admin/setting/customers/create", body);
    if (result?.status) {
      this.setState({ customer_id: result.data }, () => {
        this.Create();
      });
    } else {
      loading(false);
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
      this.Get(1);
    }
  };
  onClickEdit = (item) => {
 window.location.href =
                                "/repair/detail-repairs?id=" + item.uid +(["ยกเลิก","เสร็จสิ้น","อัพเดทต้นทุนเสร็จสิ้น"].includes(item.status) ? " &type=view": "");
  }
  PrintReceiptTax = async (uid, document_no) => {
    loading(true);
    let cash_amount = 0;
    let transfer_amount = 0;
    let credit_amount = 0;

    let result = await GET("admin/sales/list-payment", {
      data_search: document_no,
    });

    if (result?.status && Array.isArray(result.data)) {
      for (const payment of result.data.filter((e) => e.sale || e.repair)) {
        cash_amount += Number(payment.cash_amount || 0);
        transfer_amount += Number(payment.transfer_amount || 0);
        credit_amount += Number(payment.credit_amount || 0);
      }
    }

    await report_receipt_tax(uid, {
      type: "repair",
      compact: true,
      cash_amount: cash_amount,
      transfer_amount: transfer_amount,
      transfer_bank_account: "",
      transfer_date: "",
      transfer_time: "",
      credit_amount: credit_amount,
      credit_bank_account: "",
      credit_date: "",
      check_number: "",
    });
    loading(false);
  };
  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_status,
      data,
      count,
      data_customer,
      data_user,
      data_warehouse,
      id,
      uid,
      date,
      type,
      customer_id,
      customer_name,
      address,
      phone,
      car_registration,
      brand,
      model,
      cause,
      status,
      user_id,
      warehouse_id,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายการแจ้งซ่อม</h4>
              <button
                className="btn btn-dark px-3 ms-auto mb-2 banks.create"
                onClick={async () => {
                  this.setState({
                    modal_create: true,
                    id: "",
                    uid: "",
                    date: format_date(new Date(), "yyyy-mm-dd", "en"),
                    type: "",
                    customer_id: "",
                    customer_name: "",
                    address: "",
                    phone: "",
                    car_registration: "",
                    brand: "",
                    model: "",
                    cause: "",
                    status: "",
                    user_id: "",
                    warehouse_id: "",
                  });
                }}
              >
                เพิ่มรายการ
              </button>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <select
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_status: e.target.value });
                }}
                value={filter_status}
              >
                <option value="">เลือกสถานะ</option>
                <option value="เข้าซ่อม">เข้าซ่อม</option>
                <option value="รอบันทึกยอดเงิน">รอบันทึกยอดเงิน</option>
                <option value="รอชำระ">รอชำระ</option>
                <option value="เสร็จสิ้น,อัพเดทต้นทุนเสร็จสิ้น">เสร็จสิ้น</option>
                <option value="ยกเลิก">ยกเลิก</option>
              </select>

              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">เลขที่ใบแจ้งซ่อม</td>
                    <td className="text-nowrap">วันที่แจ้ง</td>
                    <td className="text-nowrap">ชื่อลูกค้า</td>
                    <td className="text-nowrap">ทะเบียนรถ</td>
                    <td className="text-nowrap">อื่นๆ</td>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap">ช่างผู้รับผิดชอบ</td>
                    <td className="text-nowrap">สถานะ</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap" onClick={() => {this.onClickEdit(item);}}>{item.document_no}</td>
                      <td className="text-nowrap" onClick={() => {this.onClickEdit(item);}}>
                        {item.date ? format_date(item.date) : ""}
                      </td>
                      <td className="text-nowrap" onClick={() => {this.onClickEdit(item);}}>
                        {item.customer?.full_name || ""}
                      </td>
                      <td className="text-nowrap" onClick={() => {this.onClickEdit(item);}}>
                        {item.car_registration || ""}
                      </td>
                      <td className="text-nowrap" onClick={() => {this.onClickEdit(item);}}>
                        {item.model || ""}
                      </td>
                      <td className="text-nowrap" onClick={() => {this.onClickEdit(item);}}>
                        {item.warehouse?.name || ""}
                      </td>
                      <td className="text-nowrap" onClick={() => {this.onClickEdit(item);}}>
                        {item.user?.full_name || ""}
                      </td>
                      <td className="text-nowrap" onClick={() => {this.onClickEdit(item);}}>{item.status === "อัพเดทต้นทุนเสร็จสิ้น" ? "เสร็จสิ้น" : item.status}</td>
                      <td className="text-center align-middle wpx-100">
                        
                        <div className="d-flex">

                          {["ยกเลิก","เสร็จสิ้น","อัพเดทต้นทุนเสร็จสิ้น"].includes(item.status) && (
                          <BtnIcon
                            type="view"
                            onClick={() => {
                              window.location.href =
                                "/repair/detail-repairs?id=" + item.uid +" &type=view";
                            }}
                          />

                          )}
                          {!["ยกเลิก","เสร็จสิ้น","อัพเดทต้นทุนเสร็จสิ้น"].includes(item.status) && (
                          <BtnIcon
                            className="banks.update"
                            type="update"
                            onClick={() => {
                              window.location.href =
                                "/repair/detail-repairs?id=" + item.uid;
                            }}
                          />
                        )}
                        <BtnIcon
                          type="print"
                          onClick={() => {
                            const canPrintReceiptTax = [
                              "รอชำระ",
                              "เสร็จสิ้น",
                              "อัพเดทต้นทุนเสร็จสิ้น",
                            ].includes(item.status);
                            Swal.fire({
                                    title: "พิมพ์เอกสาร",
                                    text: "",
                                    html:`
                                      <div class="w-100">
                                        ${
                                          canPrintReceiptTax
                                            ? `<button id="report-receipt-tax" class="btn btn-outline-dark w-100 mb-3 text-start">
                                          <span class="icon me-2">&#xf15b;</span>
                                          ใบเสร็จรับเงิน/ใบกำกับภาษี
                                        </button>`
                                            : ""
                                        }
                                        <button id="report-installation-summary" class="btn btn-outline-dark w-100 mb-3 text-start">
                                          <span class="icon me-2">&#xf15b;</span>
                                          ใบสรุปรายการติดตั้ง
                                        </button>
                                        <button id="report-repair" class="btn btn-outline-dark w-100 mb-3 text-start">
                                          <span class="icon me-2">&#xf15b;</span>
                                          ใบแจ้งซ่อม
                                        </button>
                                        <button id="report-receipt" class="btn btn-outline-dark w-100 mb-3 text-start">
                                          <span class="icon me-2">&#xf15b;</span>
                                          ใบรับงาน
                                        </button>
                                      </div>
                                    `,
                                    showConfirmButton: false,
                                    showCancelButton: false,
                                    showCloseButton: true, didOpen: () => {
                                      if (canPrintReceiptTax) {
                                        document.getElementById("report-receipt-tax").addEventListener("click", () => {
                                          this.PrintReceiptTax(item.uid, item.document_no);
                                        });
                                      }
                                      document.getElementById("report-receipt").addEventListener("click", () => {
                                        report_car_receipt(item.uid);
                                      });
                                      document.getElementById("report-repair").addEventListener("click", () => {
                                        report_repair(item.uid);
                                      });
                                      document.getElementById("report-installation-summary").addEventListener("click", () => {
                                        report_installation_summary(item.uid);
                                      });
                                    },
                                  })
                          }}
                        />
                          {["เข้าซ่อม","เสร็จสิ้น","รอชำระ","รอบันทึกยอดเงิน"].includes(item.status) && (
                          <BtnIcon
                            className="banks.delete"
                            type="delete"
                            onClick={() => {
                              this.Delete( item.uid);
                            }}
                          />

                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_create}
          onHide={() => this.setState({ modal_create: false })}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">เพิ่มใบแจ้งซ่อม</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">วันที่แจ้งซ่อม{required}</div>
              <input
                type="date"
                className="form-control"
                placeholder="วันที่แจ้งซ่อม..."
                onChange={(e) => {
                  this.setState({ date: e.target.value });
                }}
                value={date}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ลูกค้า</div>
              <Select
                options={data_customer}
                className="form-control"
                placeholder="ลูกค้า..."
                onChange={(e, i) => {
                  this.setState({
                    customer_id: e,
                    customer_name: e ? i.full_name : "",
                    phone: e ? i.phone : "",
                  });
                }}
                value={customer_id}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ชื่อลูกค้า{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อลูกค้า..."
                onChange={(e) => {
                  this.setState({ customer_name: e.target.value });
                }}
                value={customer_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">เบอร์โทร{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="เบอร์โทร..."
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ phone: e.target.value });
                }}
                value={phone}
                maxLength={10}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ทะเบียนรถ/เลขเครื่อง</div>
              <input
                type="text"
                className="form-control"
                placeholder="ทะเบียนรถ..."
                onChange={(e) => {
                  this.setState({ car_registration: e.target.value });
                }}
                value={car_registration}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">อื่นๆ</div>
              <input
                type="text"
                className="form-control"
                placeholder="อื่นๆ..."
                onChange={(e) => {
                  this.setState({ model: e.target.value });
                }}
                value={model}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ยี่ห้อ/รุ่น</div>
              <input
                type="text"
                className="form-control"
                placeholder="ยี่ห้อ/รุ่น..."
                onChange={(e) => {
                  this.setState({ brand: e.target.value });
                }}
                value={brand}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ประเภทการซ่อม{required}</div>
              <select
                className="form-control"
                placeholder="ประเภทการซ่อม..."
                onChange={(e) => {
                  this.setState({ type: e.target.value });
                }}
                value={type}
              >
                <option value="">-- เลือกประเภทการซ่อม --</option>
                <option value="ซ่อมให้ลูกค้า">ซ่อมให้ลูกค้า</option>
                <option value="ซ่อมภายใน">ซ่อมภายใน</option>
                <option value="ประกอบ">ประกอบ</option>
              </select>
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">คลังสินค้า{required}</div>
              <Select
                className="form-control"
                placeholder="คลังสินค้า..."
                options={data_warehouse.filter(e=>(e.label).includes("ซ่อม"))}
                onChange={(e) => {
                  this.setState({ warehouse_id: e, user_id: "" });
                }}
                value={warehouse_id}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ผู้รับงาน{required}</div>
              <Select
                className="form-control"
                placeholder="ผู้รับงาน..."
                options={data_user.filter(e=>e.warehouse_list?.includes(data_warehouse.find(w=>w.value === warehouse_id)?.id))}
                onChange={(e) => {
                  this.setState({ user_id: e });
                }}
                value={user_id}
                disabled={!warehouse_id}
              />
            </div>
            
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">สาเหตุเบื้องต้น{required}</div>
              <textarea
                className="form-control"
                placeholder="สาเหตุเบื้องต้น..."
                onChange={(e) => {
                  this.setState({ cause: e.target.value });
                }}
                value={cause}
                rows={8}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  if (!date.trim()) {
                    alert(
                      "",
                      "warning",
                      "แจ้งเตือน",
                      "กรุณาเลือกวันที่แจ้งซ่อม"
                    );
                    return;
                  } else if (!customer_name.trim() && type !== "ประกอบ") {
                    alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อลูกค้า");
                    return;
                  } else if (!phone.trim() && type !== "ประกอบ") {
                    alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรศัพท์");
                    return;
                  } else if (!type.trim()) {
                    alert(
                      "",
                      "warning",
                      "แจ้งเตือน",
                      "กรุณาเลือกประเภทการซ่อม"
                    );
                    return;
                  } else if (!user_id?.trim()) {
                    alert("", "warning", "แจ้งเตือน", "กรุณาเลือกผู้รับงาน");
                    return;
                  } else if (!warehouse_id?.trim()) {
                    alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
                    return;
                  } else if (!cause?.trim()) {
                    alert("", "warning", "แจ้งเตือน", "กรุณากรอกสาเหตุเบื้องต้น");
                    return;
                  }
                  if(type === "ประกอบ"){
                    this.Create();
                  }else{
                    if (customer_id) {
                    this.Create();
                  } else {
                    this.CreateCustomer();
                  }
                  }
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
